import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

@Injectable({ providedIn: 'root' })
export class LessonExcelImportService {
  private apiUrl = `${environment.baseUrl}/lessonExcelImport`;

  constructor(private commonAPI: CommonApiService) {}

  private userId(): number {
    return Number(this.commonAPI.userInfo?.userID ?? this.commonAPI.userInfo?.userId);
  }

  listLessons(): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/listLessons`, {
      criteria: { userId: this.userId(), tenant: null },
    });
  }

  createLesson(lessonTitle: string, lessonSubject = ''): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/createLesson`, {
      criteria: {
        userId: this.userId(),
        lessonTitle,
        lessonSubject,
        tenant: null,
      },
    });
  }

  uploadExcel(lessonId: number, fileName: string, fileBase64: string): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/uploadExcel`, {
      criteria: {
        userId: this.userId(),
        lessonId,
        fileName,
        fileBase64,
        tenant: null,
      },
    });
  }

  checkExcel(lessonId: number): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/checkExcel`, {
      criteria: { userId: this.userId(), lessonId, tenant: null },
    });
  }

  uploadImageZip(lessonId: number, fileName: string, fileBase64: string, overwrite = false): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/uploadImageZip`, {
      criteria: {
        userId: this.userId(),
        lessonId,
        fileName,
        fileBase64,
        overwrite: overwrite === true,
        tenant: null,
      },
    });
  }

  /** ZIP of lesson slide images in upload layout: <slideId>/<file> */
  downloadImageZip(lessonId: number): Observable<Blob> {
    return this.commonAPI.postApiCallForFile(`${this.apiUrl}/downloadImageZip`, {
      criteria: { userId: this.userId(), lessonId, tenant: null },
    });
  }

  populateLesson(lessonId: number): Observable<any> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/populateLesson`, {
      criteria: { userId: this.userId(), lessonId, tenant: null },
    });
  }
}
